import React, { useState, useEffect } from "react";
import i18n from "../i18n";

// Transforme un lien YouTube classique (watch, youtu.be, shorts) en lien embed,
// seul format accepté par l'iframe de la page tuto. Les autres URL sont gardées telles quelles.
const toEmbedUrl = (url) => {
  const trimmed = url.trim();
  const match = trimmed.match(
    /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/)|youtu\.be\/)([\w-]{11})/
  );
  return match ? `https://www.youtube.com/embed/${match[1]}` : trimmed;
};

const CustomTutoVideo = ({ formData, setFormData }) => {
  const [videoUrl, setVideoUrl] = useState("");
  const [isEditing, setIsEditing] = useState(true);

  // synchro si déjà présent dans formData (édition d’un existant)
  useEffect(() => {
    if (formData.custom_intro_video) {
      setVideoUrl(formData.custom_intro_video);
      setIsEditing(false);
    }
  }, [formData.custom_intro_video]);

  // Vidéo affichée aux joueurs si aucune vidéo personnalisée n'est définie
  const defaultVideo = i18n.getFixedT(formData.language || "fr")("tuto-video-link");

  const handleValidate = () => {
    if (!videoUrl.trim()) return;

    const embedUrl = toEmbedUrl(videoUrl);
    setFormData((prev) => ({
      ...prev,
      custom_intro_video: embedUrl,
    }));

    setVideoUrl(embedUrl);
    setIsEditing(false);
  };

  const handleRemove = () => {
    setFormData((prev) => ({
      ...prev,
      custom_intro_video: null,
    }));

    setVideoUrl("");
    setIsEditing(true);
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  return (
    <div className="custom-tuto-video">

      <h4>Vidéo tuto des règles personnalisée</h4>

      {isEditing ? (
        <>
          <div className="custom-tuto-video-input">
            <input
              type="text"
              value={videoUrl}
              onChange={(e) => setVideoUrl(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleValidate();
                }
              }}
              placeholder="URL de la vidéo (YouTube ou .mp4)"
              className="custom-intro-input"
            />

            <button
              type="button"
              onClick={handleValidate}
              className="custom-intro-add-button"
            >
              Valider
            </button>
          </div>

          <p className="custom-tuto-video-hint">
            Sans vidéo personnalisée, la vidéo par défaut de la langue de l’atelier est utilisée :{" "}
            <a href={defaultVideo} target="_blank" rel="noreferrer">
              voir la vidéo par défaut
            </a>
          </p>
        </>
      ) : (
        <>
          {/* 🎬 PREVIEW */}
          <div className="custom-tuto-video-preview">
            <iframe
              width="400"
              height="225"
              src={formData.custom_intro_video}
              title="Vidéo tuto personnalisée"
              frameBorder="0"
              allow="encrypted-media; picture-in-picture; fullscreen"
            ></iframe>
          </div>

          {/* 🎛 ACTIONS */}
          <div className="custom-tuto-video-actions">
            <button
              type="button"
              onClick={handleEdit}
              className="slide-move-button"
            >
              Modifier
            </button>

            <button
              type="button"
              onClick={handleRemove}
              className="custom-intro-remove-button"
            >
              Supprimer
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CustomTutoVideo;
